import React, { Component, Fragment } from 'react';
import {FormattedMessage} from "react-intl";

class QualityComplaintTableHeader extends Component {
    render() {
        return (
            <thead>
            <tr>
                <th>
                    <FormattedMessage id="app.admin-inquiry-header.date"
                                      defaultMessage="Date & Time"
                                      description=""/>
                </th>
                <th> ユーザー名</th>
                <th>
                    <FormattedMessage id="app.admin-inquiry-header.subject"
                                      defaultMessage="Subject"
                                      description=""/>
                </th>
                <th>
                    <FormattedMessage id="app.admin-inquiry-header.status-title"
                                      defaultMessage="Status"
                                      description=""/>
                </th>
                <th>

                </th>
                <th>
                    <FormattedMessage id="app.admin-inquiry-header.actions"
                                      defaultMessage="Actions"
                                      description=""/>
                </th>
            </tr>
            </thead>
        );
    }
}

export default QualityComplaintTableHeader;


// WEBPACK FOOTER //
// ./src/components/Admin/NewQualityComplaint/QualityComplaintTableHeader/QualityComplaintTableHeader.js